// GET_CURRENCY
export const GET_CRYPTO = "GET_CRYPTO";
export const GET_CRYPTO_FAIL = "GET_CRYPTO_FAIL";
export const GET_CRYPTO_SUCCESS = "GET_CRYPTO_SUCCESS";

